import type { JsonLd } from 'json-ld-types';

import { traverse } from '@atlaskit/adf-utils/traverse/main';
import type { ADFEntity, Visitor } from '@atlaskit/adf-utils/types';
import type { CardContext } from '@atlaskit/link-provider/types';

export interface LinkData {
	name: string;
	tenantId: string;
	product: string;
}

const forEachSmartLink = (content: ADFEntity, handle: (url: string) => void) => {
	const handleCard: Visitor = (node) => {
		const url = node.attrs?.url;
		if (url) handle(url);
	};

	traverse(content, {
		inlineCard: handleCard,
		blockCard: handleCard,
		embedCard: handleCard,
	});
};

export const getJiraSmartLinks = (
	content: ADFEntity,
	store: CardContext['store'],
): Record<string, LinkData> => {
	const links: Record<string, LinkData> = {};

	forEachSmartLink(content, (url) => {
		const details = store.getState()[url]?.details;
		if (!details) return;

		const { name } = details.data as JsonLd.Data.BaseData;
		const { tenantId, product, subproduct } = details.meta;
		if (!name || !tenantId || product !== 'jira' || subproduct != 'software') return;

		const fullProduct = product === 'jira' ? `${product}-${subproduct}` : product;
		links[url] = { name, tenantId, product: fullProduct };
	});

	return links;
};

export const getAllSmartLinks = (content: ADFEntity): Set<string> => {
	const links = new Set<string>();
	forEachSmartLink(content, (url) => links.add(url));
	return links;
};
